// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>16</span>&nbsp;&nbsp;The eyes of all wait upon you, O Lord,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and you give them their food in due season.<br> </p> </div></div>";
// Exports
module.exports = code;